function slugify(value = "") {
  return String(value)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function buildPublicTherapistPath(therapist) {
  if (!therapist) return "";

  const profileSlug = String(
    therapist.public_slug || therapist.slug || therapist.username || ""
  ).trim();
  if (!profileSlug) return therapist?._id ? `/therapists/${therapist._id}` : "";

  const specialties = Array.isArray(therapist.specialties)
    ? therapist.specialties
    : [];
  const fieldsOfExpertise = Array.isArray(therapist.fields_of_expertise)
    ? therapist.fields_of_expertise
    : [];
  const firstSpeciality =
    specialties.find((item) => String(item || "").trim()) ||
    fieldsOfExpertise.find((item) => String(item || "").trim()) ||
    "accompagnement-bien-etre";

  const specialtySlug = slugify(firstSpeciality) || "accompagnement-bien-etre";

  const firstOffice = Array.isArray(therapist.offices)
    ? therapist.offices.find((office) => office?.is_default) ||
      therapist.offices[0] ||
      null
    : null;
  const citySlug =
    slugify(
      firstOffice?.city_slug || firstOffice?.city || therapist.city || ""
    ) || "france";

  return `/therapeutes/${specialtySlug}/${citySlug}/${profileSlug}`;
}

export function buildPublicBookingPath(therapist, canonicalProfilePath = "") {
  const publicProfilePath =
    String(canonicalProfilePath || "").trim() ||
    buildPublicTherapistPath(therapist);
  if (!publicProfilePath) return "";
  return `${publicProfilePath}/prendre-rendez-vous`;
}
